<div *ngIf="dados" class="document-preview">
  <img src="assets/img/header_sg.jpg" class="doc-header-img" alt="Cabeçalho">

  <h2 class="doc-center">UNIVERSIDADE ESTADUAL DE CAMPINAS</h2>
  <h3 class="doc-center">{{ dados.dadosConcurso.nomeUnidade }}</h3>
  <h3 class="doc-center" style="text-transform:none">EDITAL DE RETIFICAÇÃO DA RELAÇÃO DE APROVADOS PcDs</h3>
  <p class="doc-center"><strong>(Proc. nº {{ dados.dadosConcurso.processoSigad }})</strong></p>

  <p style="text-align:justify; white-space:pre-line">{{ dados.textoIntrodutorio }}</p>

  <h4 class="doc-center" style="margin-top:2em">Classificação PcD</h4>
  <table>
    <thead>
      <tr>
        <th>Nº Inscrição</th>
        <th>Nome do Candidato</th>
        <th>Classificação</th>
        <th style="width:48px"></th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let linha of linhas; let i = index">
        <td><input class="cell-input" [(ngModel)]="linha.inscricao" (ngModelChange)="onLinhaChange()" placeholder="Nº inscrição"></td>
        <td><input class="cell-input cell-input-upper" [(ngModel)]="linha.nome" (ngModelChange)="onLinhaChange()" placeholder="Nome do candidato"></td>
        <td><input class="cell-input" [(ngModel)]="linha.classificacao" (ngModelChange)="onLinhaChange()" placeholder="Classificação"></td>
        <td class="col-acao">
          <button mat-icon-button color="warn" type="button" class="btn-acao-linha" (click)="removerLinha(i)" title="Remover linha" aria-label="Remover linha">
            <mat-icon>delete</mat-icon>
          </button>
        </td>
      </tr>
      <tr *ngIf="linhas.length === 0">
        <td colspan="4" style="text-align:center; font-style:italic">Nenhuma linha. Clique em "Adicionar linha".</td>
      </tr>
    </tbody>
  </table>

  <button mat-stroked-button color="primary" type="button" class="btn-adicionar-linha" (click)="adicionarLinha()">
    <mat-icon>add</mat-icon> Adicionar linha
  </button>

  <p style="text-align:justify; margin-top:1.5em">Os demais itens permanecem inalterados.</p>

  <div class="doc-footer">
    <p>Campinas,
      <mat-form-field appearance="outline" class="inline-field">
        <mat-label>Data</mat-label>
        <input matInput [(ngModel)]="campos['dataDocumento']" (ngModelChange)="onCampoChange('dataDocumento', $event)" mask="00/00/0000" [dropSpecialCharacters]="false" placeholder="dd/mm/aaaa">
      </mat-form-field>.
    </p>
  </div>
</div>
